import { createSelector } from '@atlassian/jira-common-selectors';
import type { ConfigState } from '../../reducers/config/types';
import type { VersionsState } from '../../reducers/entities/versions/types';
import type { State } from '../../types';
import { getEntities } from '../entities';

const getConfig = (state: State): ConfigState => state.config;

export const getEntitiesVersions = (state: State): VersionsState => getEntities(state).versions;

export const getVersionsOrder = (state: State): string[] => getEntities(state).version.versions;

export const isVersionsFeatureEnabled: (state: State) => boolean = createSelector(
	[getConfig],
	(config: ConfigState): boolean => config.version.isVersionsFeatureEnabled || false,
);
